import CloudOffIcon from '@mui/icons-material/CloudOff';
import SyncIcon from '@mui/icons-material/Sync';
import { Box, Stack, Typography } from '@mui/material';
import { useBetQueue } from '../hooks/useBetQueue';
import { useOnline } from '../hooks/useOnline';
import { colors, mono } from '../themes/theme';

/**
 * Explains a dead connection instead of leaving every screen to fail on its
 * own. Also the only place a queued bet is visible, so nobody is left
 * wondering whether it landed.
 */
export function ConnectionBar() {
    const online = useOnline();
    const { pending, flushing } = useBetQueue();

    if (online && pending.length === 0) return null;

    const waiting = pending.length;

    return (
        <Box
            sx={{
                bgcolor: online ? colors.raised : colors.loss,
                color: online ? colors.ink : colors.ground,
                px: 2,
                py: 0.75,
                borderRadius: '3px',
                mb: 1.5,
            }}
        >
            <Stack direction="row" spacing={1} alignItems="center">
                {online ? <SyncIcon fontSize="small" /> : <CloudOffIcon fontSize="small" />}
                <Typography
                    sx={{
                        fontFamily: mono,
                        fontSize: '0.72rem',
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                    }}
                >
                    {!online
                        ? waiting > 0
                            ? `Offline — ${waiting} bet${waiting === 1 ? '' : 's'} waiting`
                            : 'Offline — showing the last thing loaded'
                        : flushing
                          ? `Sending ${waiting} bet${waiting === 1 ? '' : 's'}…`
                          : `${waiting} bet${waiting === 1 ? '' : 's'} still to send`}
                </Typography>
            </Stack>
        </Box>
    );
}
